import fetchBuilder, { RequestInitRetryParams } from "fetch-retry";
import { basePath } from "../settings";
import { ApiResponse, AppControllerApi, BaseAPI, Configuration, JobControllerApi, ProteinControllerApi, StaticFileControllerApi } from './openapi-generator';
import { createSimpleRetryStrategy } from "@loschmidt/commons";

// noinspection JSUnusedGlobalSymbols
export interface ErrorResponse {
    timestamp: string;
    status: number;
    error: string;
    message: string;
    path: string;
}

const RETRIES = 2;  // + the original

const fetchBuilderDefaults: RequestInitRetryParams = {
    retryDelay: (attempt) => Math.pow(2, attempt) * 1000, // 1000, 2000, 4000
    retryOn: createSimpleRetryStrategy(RETRIES),
}

export const fetchRetry = fetchBuilder(fetch, fetchBuilderDefaults);

const fetchOrFetchRetry: typeof fetch = (input, init) => {
    let method = 'GET';
    if (input instanceof Request && input.method) {
        method = input.method.toUpperCase();
    }
    const f = method === 'POST' ? fetch : fetchRetry;
    // @ts-ignore
    return f(input, init);
}

// getApiUrl -->
type MethodKeysWithReturnType<T, R> = {[K in keyof T]: T[K] extends (...args: any[]) => R ? K : never}[keyof T];
type RawResponseMethodKeys<T> = MethodKeysWithReturnType<T, Promise<ApiResponse<any>>>;
type MethodParams<T, K extends keyof T> = T[K] extends (...args: infer P) => any ? P : never;
const getApiUrlConfig = new Configuration({
    basePath: basePath,
    fetchApi: async (url) => {
        // no fetching, just return URL itself as a response
        return new Response(url as any as string);
    },
});
// OpenAPI Generator does not provide a way how to get URLs.
// It has URLs hard-coded in methods which execute the fetching.
// Here in getApiUrl, we use custom "fetcher" instead of native fetch (see getApiUrlConfig).
// Our "fetcher" doesn't contact the backend, only returns URL as a "response".
export async function getApiUrl<
  T extends typeof BaseAPI,
  K extends RawResponseMethodKeys<InstanceType<T>>
>(controller: T, key: K, ...params: MethodParams<InstanceType<T>, K>) {
    const instance = new controller(getApiUrlConfig) as InstanceType<T>;
    const method = instance[key] as (...args: typeof params) => Promise<ApiResponse<any>>;
    const response = await method.call(instance, ...params);  // used call to bind instance as "this"
    return response.raw.text();
}
// <-- getApiUrl

const config = new Configuration({
    basePath: basePath,
    fetchApi: fetchOrFetchRetry,
});

export const ProteinApi = new ProteinControllerApi(config);
export const JobApi = new JobControllerApi(config);
export const StaticFileApi = new StaticFileControllerApi(config);
export const AppApi = new AppControllerApi(config);
